import { render, staticRenderFns } from "./OrgSettingsFunds.vue?vue&type=template&id=9369d5ba&scoped=true&"
import script from "./OrgSettingsFunds.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsFunds.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettingsFunds.vue?vue&type=style&index=0&id=9369d5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9369d5ba",
  null
  
)

export default component.exports